<template>
  <div class="home-page">
    <!-- 背景图片 -->
    <img class="page-bg" :src="bgImage" alt="背景"/>

    <!-- Logo -->
    <img class="page-logo" :src="logoImage" alt="Logo"/>

    <!-- 返回按钮 -->
    <img class="page-back-btn" @click="handleBack" :src="backButtonImage" alt="返回"/>

    <!-- 内容区域 -->
    <div class="content-box">
      <!-- 数据内容 -->
      <template>
        <div class="new-basic-bg">
          <img class="basic-bg" :src="container611Image" alt="容器背景"/>
          <div class="basic-name">{{ reportData.bizUser?.name || '--' }}</div>
          <img class="basic-sec" v-if="reportData.bizUser?.sex === 1" :src="nanimg" alt="">
          <img class="basic-sec" v-else-if="reportData.bizUser?.sex === 2" :src="sexImg" alt="">
          <div class="basic-message-box">
            <div class="">{{ reportData.bizUser?.age || '--' }} 岁</div>
            <div class="">{{ reportData.bizUser?.height || '--' }}cm</div>
            <div class="">{{ reportData.bizUser?.weight || '--' }}kg</div>
          </div>
          <div class="basic-date">{{ parseCustomDate(reportData.reportTime) }}</div>
          <div class="basic-soc">{{ reportData.score || '--' }}分</div>
          <div class="echarts-box">
            <newChart :option="ringChartOption" />
          </div>
        </div>

        <div class="tab-box">
          <img :src="tabMessage" alt="">
          <div class="tab-select">
            <div class="tab-item" @click="goToPsychologicalAge"></div>
            <div class="tab-item" @click="goToTongueDiagnosis"></div>
            <div class="tab-item" @click="goToPulseDiagnosis"></div>
            <div class="tab-item" @click="goToHealthService"></div>
          </div>
        </div>


                <!-- 体质辩证 -->
        <div v-if="reportData.bizTongue" class="bodyMass-box">
          <div class="baige">
            <div class="bodyMass-title">辨证体质
              <!-- <div class="bodyMass-div"></div> -->
            </div>
            <div class="bodyMass-result">
              <img :src="container649Image" alt="容器"/>
              <div>{{ reportData.bizTongue.constitutionnames || '--' }}</div>
            </div>
            <div class="explain-box">
              释义：<br>
              <div v-html="occurReasonText"></div>
            </div>
            <div style="height: 30rpx;position: relative;"></div>
          </div>
        </div>

        <!-- 气血状态 -->
        <div v-if="reportData.bloodStatusVo" class="qiAndBlood-box">
         <div class="baige">  
          <div class="bodyMass-title">气血状态
            <!-- <div class="bodyMass-div"></div> -->
          </div>
          <div class="yinyang-box">
            <img class="yinyang-biaozhun" :src="container639Image" alt="标准图"/>
          <!-- 阳半圆环图表 -->
          <div class="yang-echarts">
            <newChart 
              v-if="reportData.bloodStatusVo"
              :option="yangChartOption"
            />
          </div>
          <!-- 阴半圆环图表 -->
          <div class="yin-echarts">
            <newChart 
              v-if="reportData.bloodStatusVo"
              :option="yinChartOption"
            />
          </div>
            <div class="yangzhishu">
              阳指数：<span class="yang-value">{{ reportData.bloodStatusVo.yangIndex || '--' }}</span>
            </div>
            <div class="yinzhishu">
              阴指数：<span class="yin-value">{{ reportData.bloodStatusVo.yinIndex || '--' }}</span>
            </div>
          </div>
          <div class="yinyang-message">
            <div>阴阳偏胜(盛)：即一方过强 <br>阳胜则热：会导致实热证(如高热、面红、口渴) 。<br> 阴胜则寒：会导致实寒证(如畏寒、肢冷、腹痛)。</div>
            <div>阴阳偏衰(虚)：即一方过弱 <br> 阳虚则寒：会导致虚寒证(如畏寒、精神不振、小便清长)。<br> 阴虚则热：会导致虚热证(如午后潮热、盗汗、口干咽燥)。</div>
            <div>阴阳互损：一方虚损到一定程度，会导致另一方也不足。<br> 即"阳损及阴""阴损及阳"，最终导致"阴阳两虚"</div>
          </div>
         </div> 
        </div>

        <!-- 健康评估 -->
        <div v-if="reportData.bizUser" class="health-box">
         <div class="baige"> 
          <div class="bodyMass-title">健康评估
            <!-- <div class="bodyMass-div"></div> -->
          </div>
          <div class="health-body">
            <img class="health-body-img" :src="healthBodyImage" alt="人体图"/>
            <div class="health-line-left">
              <div
                  @click="goToHealthAssessment(1)"
                  :class="['health-line-left-item', getHealthItemClass(reportData.bizUser.eyes)]"
              >
                眼部健康值:{{ reportData.bizUser.eyes || '无' }}
              </div>
              <div
                  @click="goToHealthAssessment(2)"
                  :class="['health-line-left-item', getHealthItemClass(reportData.bizUser.skin)]"
              >
                皮肤健康值:{{ reportData.bizUser.skin || '无' }}
              </div>
              <div
                  @click="goToHealthAssessment(3)"
                  :class="['health-line-left-item', getHealthItemClass(reportData.bizUser.breathing)]"
              >
                呼吸健康值:{{ reportData.bizUser.breathing || '无' }}
              </div>
              <div
                  @click="goToHealthAssessment(4)"
                  :class="['health-line-left-item', getHealthItemClass(reportData.bizUser.liver)]"
              >
                肝胆健康值:{{ reportData.bizUser.liver || '无' }}
              </div>
              <div
                  @click="goToHealthAssessment(5)"
                  :class="['health-line-left-item', getHealthItemClass(reportData.bizUser.stomach)]"
              >
                肠胃健康值:{{ reportData.bizUser.stomach || '无' }}
              </div>
              <div
                  @click="goToHealthAssessment(6)"
                  :class="['health-line-left-item', getHealthItemClass(reportData.bizUser.kidney)]"
              >
                肾脏健康值:{{ reportData.bizUser.kidney || '无' }}
              </div>
            </div>
            <div class="health-line-right">
              <div
                  @click="goToHealthAssessment(7)"
                  :class="['health-line-right-item', getHealthItemClass(reportData.bizUser.immune)]"
              >
                免疫健康值:{{ reportData.bizUser.immune || '无' }}
              </div>
              <div
                  @click="goToHealthAssessment(8)"
                  :class="['health-line-right-item', getHealthItemClass(reportData.bizUser.vitamin)]"
              >
                维生素健康值:{{ reportData.bizUser.vitamin || '无' }}
              </div>
              <div
                  @click="goToHealthAssessment(9)"
                  :class="['health-line-right-item', getHealthItemClass(reportData.bizUser.bloodVessel)]"
              >
                心脑血管值:{{ reportData.bizUser.bloodVessel || '无' }}
              </div>
              <div
                  @click="goToHealthAssessment(10)"
                  :class="['health-line-right-item', getHealthItemClass(reportData.bizUser.endocrine)]"
              >
                内分泌健康值:{{ reportData.bizUser.endocrine || '无' }}
              </div>
              <div
                  @click="goToHealthAssessment(11)"
                  :class="['health-line-right-item', getHealthItemClass(reportData.bizUser.gynaecology)]"
              >
                男/妇科健康值:{{ reportData.bizUser.gynaecology || '无' }}
              </div>
              <div
                  @click="goToHealthAssessment(12)"
                  :class="['health-line-right-item', getHealthItemClass(reportData.bizUser.bones)]"
              >
                骨骼健康值:{{ reportData.bizUser.bones || '无' }}
              </div>
            </div>
          </div>
          <div class="health-standard">
            <div class="health-standard-item">
              <div class="health-standard-item-li">
                <div style="border: 1px solid #FF4D4F;"></div>
                <span style="color: #FF4D4F;">60以下高风险</span>
              </div>
              <div class="health-standard-item-li">
                <div style="border: 1px solid #FA8C16;"></div>
                <span style="color: #FA8C16;">60-75分中风险</span>
              </div>
            </div>
            <div class="health-standard-item">
              <div class="health-standard-item-li">
                <div style="border: 1px solid #90BB55;"></div>
                <span style="color: #90BB55;">75-90分为低风险</span>
              </div>
              <div class="health-standard-item-li">
                <div style="border: 1px solid #0E6EB8;"></div>
                <span style="color: #0E6EB8;">90分以上正常</span>
              </div>
            </div>
          </div>
         </div>  
        </div>

        <!-- 中医十二经分析 -->
        <div v-if="reportData.vesselDataVo" class="twelve-box">
         <div class="baige">   
          <div class="bodyMass-title">十二经络
            <!-- <div class="bodyMass-div"></div> -->
          </div>
          <div class="twelve-foreword">
            人体十二经是内联脏腑，外通肢节，运行气血，沟通内外，维持生命活动的十二条核心能量通道，
            以下为通过综合检测判断需注意的几大经络
          </div>
          <div class="twelve-body">
            <img class="twelve-bg" :src="meridianBodyImage" alt="经络图"/>
            <img class="twelve-type" :src="reportData.vesselDataVo.vesselImage" alt="">
            <div class="twelve-line-one" v-if="resultArray.length > 0">
              <div :style="{ width: (resultArray[0].value * 1.5) + 'px' }"></div>
              <span>{{ resultArray[0].value }}%{{ resultArray[0].name }}</span>
            </div>
            <div class="twelve-line-two" v-if="resultArray.length > 1">
              <div :style="{ width: (resultArray[1].value * 1.5) + 'px' }"></div>
              <span>{{ resultArray[1].value }}%{{ resultArray[1].name }}</span>
            </div>
            <div class="twelve-line-three" v-if="resultArray.length > 2">
              <div :style="{ width: (resultArray[2].value * 1.5) + 'px' }"></div>
              <span>{{ resultArray[2].value }}%{{ resultArray[2].name }}</span>
            </div>
            <div class="twelve-line-four" v-if="resultArray.length > 3">
              <div :style="{ width: (resultArray[3].value * 1.5) + 'px' }"></div>
              <span>{{ resultArray[3].value }}%{{ resultArray[3].name }}</span>
            </div>
            <div class="twelve-line-five" v-if="resultArray.length > 4">
              <div :style="{ width: (resultArray[4].value * 1.5) + 'px' }"></div>
              <span>{{ resultArray[4].value }}%{{ resultArray[4].name }}</span>
            </div>
          </div>
          <div
              v-for="(item, index) in vesselCharacterList"
              :key="index"
              class="twelve-jing-box"
          >
            <img class="twelve-jing-box-img" :src="item.image" alt="经络图"/>
            <div class="twelve-jing-box-message">
              <div class="twelve-jing-box-name">{{ item.vesselName }}</div>
              <div class="twelve-jing-box-title" style="color: #666;font-weight: 400;">
                主要分布{{ item.distribution }}
              </div>
              <div class="twelve-jing-box-title">
                关联脏腑：<span style="color: #FF4D4F;">{{ item.relatedOrgans }}</span>
              </div>
              <div class="twelve-jing-box-title">
                异常原因：<span
                  style="color: #666666;font-weight: 400;"
              >{{ item.specialCause }}</span>
              </div>
              <div class="twelve-jing-box-title">
                常见表现：<span
                  style="color: #666666;font-weight: 400;"
              >{{ item.commonPerformance }}</span>
              </div>
            </div>
          </div>
          <div class="twelve-jing-bottom">
            其他次级经络（肝火上炎所及之处：如目赤肿痛涉及足厥阴肝经【肝开窍于目】；失眠烦躁涉及手少阴心经。）
          </div>
         </div> 
        </div>

        <!-- 免责声明 -->
        <div class="disclaimer-box">
          <div class="disclaimer-box-title">免责声明</div>
          欢迎您使用个人健康评估报告（以下简称：健康报告），本人已经阅读健康报告服务条款并同意本声明。</br>
          <span style="text-indent: 2em;">健康报告是针对亚健康人群进行科学化数据指标采集设备，并非医疗器械设备。健康报告所有资料及数据报告仅供参考使用，不作为个人健康状况的医疗目的衡量指标，也不能替代医生和其他医务人员的专业建议。</br></span>
          <span style="text-indent: 2em;">在任何情况下，健康报告所提供数据仅为提升用户体验所用，用户对于其自身健康状况的最终评估仅来自于专业医疗机构的检测手段，健康报告对于采集数据不做任何形式的保证，不保证所提供数据满足用户的要求，对采集结果的安全性、正确性、及时性均不做保证。故本产品不对因使用本品提供的数据而导致之损失或损害承担任何直接或间接责任。</br></span>
          <span style="text-indent: 2em;">健康报告是为亚健康人群设计，相关指标依据人体数据采集系统而成，经过科学及实践测算出来，并非特别针对残缺人士及疾病患者，此类人群使用可能会出现个别指标测量不精准。</br></span>
          <span style="text-indent: 2em;">健康报告推送的内容，数据指标、运动调理、健康食谱、健康设备、调养方法等均作为个人健康管理所需的参考，不作为处方，用户可根据自身情况结合专业诊断结果进行。本产品不对通过健康报告服务得到的或在其信息平台上所推介的产品或服务做任何担保。如用户进行采纳健康报告所推送的内容所产生一切后果，本产品不承担任何责任。</br></span>
          <span style="text-indent: 2em;">健康报告是基于假定用户情况下进行的数据采集，采集结果每时每刻都在发生变化，所以建议测量选择固定时间点，最好是空腹平静心态下测量会更有效。用户通过健康报告获取材料或数据由自己承担风险，同时将对使用此类材料或数据而导致的人身或财产损失承担全部责任。</br></span>
          <span style="text-indent: 2em;">因数据报告里面包含个人隐私问题，当用户分享给它人或朋友圈时，即表示该用户自行同意把隐私公开。</br></span>
          <span style="text-indent: 2em;">本产品重视对用户隐私的保护，用户提供的登记资料及本产品保留的有关若干其他个人资料将受到中国有关隐私的法律法规的保护。非经用户亲自许可或根据相关法律的强制性规定，本产品不会主动的将用户的信息泄露给其他任何第三方。</br></span>
          <span style="text-indent: 2em;">本产品有权在必要时修改服务条款，服务条款一旦发生变动，将会在相关页面上公布修改后的服务条款。如果不同意所改动的内容，用户应主动取消此项服务。如果用户继续使用服务，则视为接受服务条款的变动。</br></span>
          <span style="text-indent: 2em;">凡以任何方式登录健康报告，或对用户使用健康报告、网络平台、与本产品相关的任何内容、服务均视为自愿接受健康报告声明的约束。无论在任何原因下（包括但不限于疏忽原因），对用户或任何人通过使用健康报告所导致的损失或损害（包括直接、间接的损失或损害），责任均由使用者自行承担（除非该等损失系由本产品质量不达标所致）。</br></span>
        </div>

        <!-- 底部间距 -->
        <div class="bottom-spacer"></div>
    

      </template>
    </div>
  </div>
</template>

<script>
/* eslint-disable */
import { mapState, mapActions } from 'vuex'
import { ROUTE_PATHS } from '@/utils/constants'
import newChart from '@/components/common/newChart.vue'
export default {
  name: 'Home',
  components: {
    newChart
  },
  data () {
    return {
      loading: false,
      // 图片资源 - Home 页面专用（使用 public 路径）
      bgImage: '/images/backgrounds/home-bg.png',
      logoImage: '/images/backgrounds/title.png',
      backButtonImage: '/images/home/header-back@1x.png',
      container611Image: '/images/home/container-611@1x.png',
      circleBgImage: '/images/home/circle-bg@2x.png',
      container649Image: '/images/home/container-649@1x.png',
      container639Image: '/images/home/container-639@1x.png',
      healthBodyImage: '/images/home/health-body@2x.png',
      meridianBodyImage: '/images/home/meridian-body@4x.png',
      projectIcon1: '/images/home/project-icon-1@1x.png',
      projectIcon2: '/images/home/project-icon-2@1x.png',
      projectIcon3: '/images/home/project-icon-3@1x.png',
      projectIcon4: '/images/home/project-icon-4@1x.png',
      tabMessage:"/images/home/tabMessage.png",
      sexImg:"/images/home/sexImg.png",
      nanimg:"/images/home/nanimg.png",
      // 圆环图配置
           // 圆环图配置
   ringChartOption: {
  series: [
    {
      type: 'gauge',
      // 缺口朝下 90 度，圆弧 270 度
      startAngle: 225,
      endAngle: 315,
      pointer: { show: false },
      progress: {
        show: true,
        width: 14,
        overlap: 0,
        roundCap: true,
        itemStyle: {
          color: '#5CC0FF',
        }
      },
      axisLine: {
        roundCap: true,
        lineStyle: {
          width: 10,
          color: [[1, '#E8E8E8']],
        }
      },
      axisTick: { show: false },
      splitLine: { show: false },
      axisLabel: { show: false },
      anchor: { show: false },
      title: { show: false },
      detail: {
        show: false,
        offsetCenter: [0, 0],
        fontSize: 28,
        fontWeight: 'bold',
        color: '#3D3D3D',
        formatter: '',
        valueAnimation: false
      },
      data: [{ value: 0 }]
    }
  ]
},   
      // 数据相关
      treatPlanJson: null,
      occurReasonText: '',
      resultArray: [],
      alert: false
    }
  },
    computed: {
    ...mapState('report', ['homeData', 'detectionNo']),
    ...mapState('user', ['userId']),
    
    reportData () {
      return this.homeData
    },
    commonPerformanceList () {
      if (!this.reportData || !this.reportData.bizTongue) return []
      // 优先使用 bizTongue.commonPerformance（数组）
      if (Array.isArray(this.reportData.bizTongue.commonPerformance)) {
        return this.reportData.bizTongue.commonPerformance
      }
      // 如果是字符串，尝试拆分
      if (typeof this.reportData.bizTongue.commonPerformance === 'string') {
        return this.reportData.bizTongue.commonPerformance.split(/[；;。]/).filter(Boolean)
      }
      // 如果都没有，尝试从 treatPlanJson 获取
      if (this.treatPlanJson && this.treatPlanJson.mainPerformance) {
        const mainPerf = this.treatPlanJson.mainPerformance
        if (typeof mainPerf === 'string') {
          return mainPerf.split(/[；;。]/).filter(Boolean)
        }
      }
      return []
    },
    vesselCharacterList () {
      if (
          !this.reportData ||
          !this.reportData.vesselDataVo ||
          !this.reportData.vesselDataVo.vesselCharacter
      ) {
        return []
      }
      return Array.isArray(this.reportData.vesselDataVo.vesselCharacter)
          ? this.reportData.vesselDataVo.vesselCharacter
          : []
    },
    
    yangChartOption() {
      return this.generateSemiCircleChartOption(
        this.reportData?.bloodStatusVo?.yangIndex || 0, 
        '#FA8C16', 
        ''
      )
    },
    
    yinChartOption() {
      return this.generateSemiCircleChartOption(
        this.reportData?.bloodStatusVo?.yinIndex || 0, 
        '#90BB55', 
        ''
      )
    }
  },
  async created () {
    await this.loadHomeData()
  },
  methods: {
        ...mapActions('report', ['fetchHomeData', 'setDetectionNo']),
    async loadHomeData () {
      this.loading = true
      this.alert = this.$route.query.alert
      try {
        // 从 URL 查询参数中获取 detectionNo
       let detectionNo = this.$route.query.id || this.$route.query.detectionNo
        // let detectionNo = "3249757038638192067666576"
        // 如果没有从当前URL获取到，尝试从页面URL中提取id参数
        if (!detectionNo) {
          const currentUrl = window.location.href
          const idMatch = currentUrl.match(/[?&]id=([^&]*)/)
          if (idMatch && idMatch[1]) {
            detectionNo = idMatch[1]
          }
        }
        
        // 如果还是没有获取到，尝试从store中获取
        if (!detectionNo && this.detectionNo) {
          detectionNo = this.detectionNo
        }
        
        if (!detectionNo) {
          console.error('缺少检测编号 id1 或 detectionNo')
          this.loading = false
          return
        }
        
        // 保存detectionNo到store
        this.setDetectionNo(detectionNo)
        
        // 调用 fetchHomeData，数据会自动存储到 store
        const data = await this.fetchHomeData({ detectionNo })

        // 处理 treatplanjson
        if (data && data.bizTongue && data.bizTongue.treatplanjson) {
          try {
            this.treatPlanJson = JSON.parse(data.bizTongue.treatplanjson)
            // 处理 occurReason
            if (Array.isArray(this.treatPlanJson.occurReason)) {
              this.occurReasonText = this.treatPlanJson.occurReason.join('<br>')
            }
          } catch (e) {
            console.error('Failed to parse treatplanjson:', e)
          }
        }

        // 处理 vesselAnalysisResult
        if (data && data.vesselDataVo && data.vesselDataVo.vesselAnalysisResult) {
          this.resultArray = Object.entries(data.vesselDataVo.vesselAnalysisResult)
              .map(([name, value]) => ({
                name,
                value: parseFloat(value) || 0
              }))
              .sort((a, b) => b.value - a.value) // 按值降序排序
              .slice(0, 5) // 只取前3个
        }
        if (data && data.score !== undefined && data.score !== null) {
          this.ringChartOption.series[0].data[0].value = data.score
        }
      } catch (error) {
        console.error('Failed to load home data:', error)
      } finally {
        this.loading = false
      }
    },
parseCustomDate (dateStr) {
  if (!dateStr) return '--'
  try {
    const parts = dateStr.split(' ')
    if (parts.length < 6) return dateStr

    const [weekday, monthAbbr, day, time, tz, year] = parts
    
    const monthMap = {
      Jan: 0, Feb: 1, Mar: 2, Apr: 3, May: 4, Jun: 5,
      Jul: 6, Aug: 7, Sep: 8, Oct: 9, Nov: 10, Dec: 11
    }

    // 直接返回 CST 日期，无需时区转换
    const month = monthMap[monthAbbr] + 1  // 月份从1开始
    return `${year}-${String(month).padStart(2, '0')}-${String(day).padStart(2, '0')}`
  } catch (e) {
    console.error('Failed to parse date:', e)
    return dateStr
  }
},
    getHealthItemClass (value) {
      if (value == null || value === '') return ''
      const num = Number(value)
      if (Number.isNaN(num)) return ''
      if (num < 70) return 'line-red'
      if (num < 75) return 'line-yellow'
      if (num < 90) return 'line-green'
      return ''
    },
    handleBack () {
      if (this.alert) {
        alert(true)
      }
    },
    goToHealthAssessment (type) {
      const sex = this.reportData?.bizUser?.sex || 0
      this.$router.push({
        path: ROUTE_PATHS.HEALTH_ASSESSMENT,
        query: {
          type,
          sex,
          userId: this.userId
        }
      })
    },
    goToPsychologicalAge () {
      this.$router.push({
        path: ROUTE_PATHS.PSYCHOLOGICAL_AGE,
        query: { userId: this.userId }
      })
    },
    goToTongueDiagnosis () {
      const detectionNo = this.$route.query.id || this.$route.query.detectionNo
      this.$router.push({
        path: ROUTE_PATHS.TONGUE_DIAGNOSIS,
        query: { id: detectionNo }
      })
    },
    goToPulseDiagnosis () {
      this.$router.push({
        path: ROUTE_PATHS.PULSE_DIAGNOSIS,
        query: { userId: this.userId }
      })
    },
    goToHealthService () {
      const detectionNo = this.$route.query.id || this.$route.query.detectionNo
      this.$router.push({
        path: ROUTE_PATHS.HEALTH_SERVICE,
        query: { id: detectionNo }
      })
    },
    
    generateSemiCircleChartOption(value, color, name) {
      // 将值规范化为0-100的范围
      const normalizedValue = Math.min(Math.max(value, 0), 100)
      
      return {
        series: [{
          type: 'gauge',
          radius: '100%',
          startAngle: 191,  // 从左下开始
          endAngle: -12,    // 到右下结束，形成拱形（底部缺少四分之一）
          min: 0,
          max: 100,
          progress: {
            show: true,
            width: 5,  // 调细进度条宽度
            roundCap: true,
            itemStyle: {
              color: color
            }
          },
          axisLine: {
            lineStyle: {
              width: 6,  // 调细轴线宽度
              color: [[1, 'rgba(0,0,0,0.1)']]
            }
          },
          axisTick: {
            show: false
          },
          axisLabel: {
            show: false
          },
          splitLine: {
            show: false
          },
          pointer: {
            show: false
          },
          detail: {
            show: false,
            valueAnimation: true,
            fontSize: 12,  // 调小字体
            color: color,
            formatter: '{value}',
            offsetCenter: [0, '0%']
          },
          data: [{
            value: normalizedValue,
            name: name
          }]
        }]
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@import '@/assets/styles/variables.scss';
@import '@/assets/styles/mixins.scss';

.home-page {
  width: 100vw;
  min-height: 100vh;
  position: relative;
  overflow-x: hidden;
}

// 背景图片
.page-bg {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  object-fit: cover;
  z-index: 0;
}

// Logo
.page-logo {
  position: absolute;
  left: 40rpx;
  top: 50rpx;
  width: 315.6rpx;
  height: 100rpx;
  z-index: 2;
}

// 返回按钮
.page-back-btn {
  position: absolute;
  left: 495rpx;
  top: 65rpx;
  width: 220rpx;
  height: 70rpx;
  border-radius: 10rpx;
  opacity: 1;
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 6rpx;
  box-sizing: border-box;
  border: 1px solid #FFFFFF;
}
.baige{
  width: 654rpx;
  background-color: #fff;
  border-radius: 20rpx;
  padding-bottom: 30rpx;
}

// 内容区域
.content-box {
  position: relative;
  left: 36rpx;
  top: 154rpx;
  width: 716rpx;
  z-index: 1;
}
.new-basic-bg{
  width: 670rpx;
  height: 256rpx;
  position: relative;
}
.basic-name{
  position: absolute;
  left: 44.85rpx;
  top: 60rpx;
  height: 48.6rpx;
  opacity: 1;
  font-family: Source Han Sans;
  font-size: 33.6rpx;
  font-weight: bold;
  line-height:48.6rpx;
  letter-spacing: 0em;
  font-variation-settings: "opsz" auto;
  font-feature-settings: "kern" on;
  color: #3D3D3D;
  z-index: 0;
}
.basic-sec{
  position: absolute;
  left: 159rpx;
  top: 66rpx;
  width: 37rpx;
  height: 37rpx;
}
.basic-message-box{
  position: absolute;
  left: 48rpx;
  top: 130.5rpx;
  width: 340rpx;
  height: 44rpx;
  opacity: 1;
  display: flex;
  flex-direction: row;
  padding: 0rpx;
  z-index: 1;
  div{
    width: 100rpx;
    height: 44rpx;
    border-radius: 10rpx;
    opacity: 1;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    font-weight: 500;
    padding: 10rpx;
    gap: 10rpx;
    margin-right: 20rpx;
    box-sizing: border-box;
    border: 1px solid #5CC0FF;
    font-size: 24rpx;
    color: #5CC0FF;
  }
}
.basic-date{
  position: absolute;
  left: 48rpx;
  top: 176rpx;
  height: 35rpx;
  opacity: 1;
  font-family: Source Han Sans;
  font-size: 24rpx;
  font-weight: 350;
  line-height: 35px;
  letter-spacing: 0em;
  font-variation-settings: "opsz" auto;
  font-feature-settings: "kern" on;
  color: #999999;
  z-index: 2;
}
.basic-soc{
  position: absolute;
  left: 475rpx;
  top: 85rpx;
  height: 52rpx;
  opacity: 1;
  font-family: Source Han Sans;
  font-size: 36rpx;
  font-weight: bold;
  line-height: normal;
  letter-spacing: 0em;
  font-variation-settings: "opsz" auto;
  font-feature-settings: "kern" on;
  background: linear-gradient(270deg, #3D8AFE 0%, #5CC0FF 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
  z-index: 0;
}
.echarts-box{
  position: absolute;
  left: 400rpx;
  top: 7.47rpx;
  width: 224rpx;
  height: 224rpx;
  opacity: 1;
}

.tab-box{
  width:670rpx;
  height:183rpx;
  position:relative;
}
.tab-box > img{
  width: 100%;
  height: 100%;
}
.tab-select{
  position: absolute;
  width: 620rpx;
  height: 139rpx;
  top: 10px;
  left: 10px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.tab-item{
  width: 100rpx;
  height: 100%;
}


// 功能入口
.project-box {
  position: relative;
  left: 0;
  width: 677rpx;
  height: 156.25rpx;
  border-radius: 26rpx;
  margin-top: 31.25rpx;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  gap: 88.54rpx;
  background: #FFFFFF;
  z-index: 1;
}

.project-box-item {
  position: static;
  width: 83.3rpx;
  height: 111.45rpx;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 6rpx;
  cursor: pointer;

  img {
    width: 78.125rpx;
    height: 78.125rpx;
    border-radius: 20rpx;
  }

  div {
    width: 83.33rpx;
    height: 30.2rpx;
    font-size: 20.83rpx;
    font-weight: 500;
    text-align: center;
    color: #3D3D3D;
  }
}

// 体质辩证
.bodyMass-box {
  position: relative;
  margin-top: 31.25rpx;
  width: 670rpx;
  border-radius: 20rpx;
  padding: 6rpx;
  box-sizing: border-box;
  background: rgba(175, 225, 255, 0.5);
  border: 2px solid rgba(255, 255, 255, 0.5);
  box-shadow: 0px 2px 10px 0px rgba(42, 150, 225, 0.3);
  z-index: 2;
}

.bodyMass-title {
  position: relative;
  left: 18.7rpx;
  top: 18.7rpx;    
  // height: 52px;
  opacity: 1;
  font-family: Source Han Sans;
  font-size: 33.6rpx;
  font-weight: 600;
  line-height: normal;
  letter-spacing: 0em;
  font-variation-settings: "opsz" auto;
  font-feature-settings: "kern" on;
  color: #3D3D3D;
  z-index: 6;
}

.bodyMass-div{
  position: absolute;
  left: 0px;
  top: 30.7rpx;
width: 140rpx;
height: 9.34rpx;
z-index: -1;
/* 主色 */
background: linear-gradient(270deg, #3D8AFE 0%, #5CC0FF 100%);
	
}

.bodyMass-resultTitle {
  position: relative;
  left: 46.875rpx;
  margin-top: 25.5rpx;
  width: 166.67rpx;
  height: 30.2rpx;
  font-size: 20.83rpx;
  font-weight: bold;
  text-align: justify;
  color: #3D3D3D;
}

.bodyMass-result {
  position: relative;
  left: 46.875rpx;
  margin-top: 30rpx;
  width: 540rpx;
  height: 100rpx;

  img {
    width: 100%;
    height: 100%;
    position: absolute;
    top: 0;
    left: 0;
  }

  div {
    position: absolute;
    top: 22.8rpx;
    width: 100%;
    height: 38.54rpx;
    text-align: center;
    font-size: 31.25rpx;
    font-weight: bold;
    color: #FFFFFF;
  }
}

.bodyMass-often {
  position: relative;
  left: 46.875rpx;
  margin-top: 40rpx;
  width: 104.17rpx;
  height: 30.2rpx;
  font-size: 20.83rpx;
  font-weight: bold;
  text-align: justify;
  color: #3D3D3D;
}

.bodyMass-oftenButton {
  display: flex;
  flex-wrap: wrap;
  gap: 13.54rpx 10.41rpx;
  padding: 6.77rpx 0;
  width: 583.33rpx;
  position: relative;
  left: 46.875rpx;
  margin-top: 13.54rpx;
  min-height: 40.625rpx;
  box-sizing: border-box;
  z-index: 2;
}

.bodyMass-oftenButton-item {
  flex: 0 0 auto;
  height: 35.125rpx;
  line-height: 31rpx;
  padding: 0 10rpx;
  font-size: 20.83rpx;
  color: #0E6EB8;
  border: 1rpx solid #0E6EB8;
  border-radius: 5.2rpx;
  background: rgba(14, 110, 184, 0.06);
  margin: 0;
  min-width: 52rpx;
  white-space: nowrap;
}

.explain-box {
  position: relative;
  left: 28.875rpx;
  margin-top: 20.8rpx;
  width: 583.33rpx;
  border-radius: 10.417rpx;
  padding: 20.83rpx 15.625rpx;
  gap: 10rpx;
  color: #3D3D3D;
  font-size: 20.83rpx;
  background: #F8F8F8;
  text-align: justify;
  line-height: 1.5;
}

// 气血状态
.qiAndBlood-box {
  position: relative;
  margin-top: 31.25rpx;
  width: 670rpx;
  padding-bottom: 30rpx;
  border-radius: 20rpx;
  padding: 6rpx;
  box-sizing: border-box;
  background: rgba(175, 225, 255, 0.5);
  border: 2px solid rgba(255, 255, 255, 0.5);
  box-shadow: 0px 2px 10px 0px rgba(42, 150, 225, 0.3);
  z-index: 2;
}

.qiAndBlood-title {
  position: relative;
  left: 0;
  top: 0;
  width: 177rpx;
  height: 46.875rpx;
  border-radius: 26rpx 26rpx 26rpx 0;
  text-align: center;
  line-height: 46.875rpx;
  font-size: 26rpx;
  color: #fff;
  display: flex;
  justify-content: center;
  align-items: center;
  background: linear-gradient(284deg, #2397F0 22%, #94DE30 99%);
}

.yinyang-box {
  position: relative;
  left: 122.3rpx;
  margin-top: 23.4375rpx;
  width: 432.29rpx;
  height: 196.875rpx;
}

.yinyang-biaozhun {
  width: 100%;
  height: 100%;
}

.yang-echarts {
  position: absolute;
  top: 56rpx;
  left: 98.5rpx;
  width: 235rpx;
  height: 235rpx;
  z-index: 2;
}

.yin-echarts {
  position: absolute;
  top: 76rpx;
  left: 115rpx;
  width: 200rpx;
  height: 200rpx;
  z-index: 2;
}



.yangzhishu {
  position: absolute;
  left: 156.25rpx;
  top: 119.27rpx;
  width: 120.3125rpx;
  height: 45.3125rpx;
  font-size: 21rpx;
  color: #FA8C16;
  line-height: 45.3125rpx;

  .yang-value {
    font-size: 31.25rpx;
    position: absolute;
    top: 1rpx;
  }
}

.yinzhishu {
  position: absolute;
  left: 156.25rpx;
  top: 151rpx;
  width: 120.3rpx;
  height: 45.3125rpx;
  font-size: 21rpx;
  color: #90BB55;
  line-height: 45.3125rpx;

  .yin-value {
    font-size: 31.25rpx;
    position: absolute;
    top: 1rpx;
  }
}

.yinyang-message {
  position: relative;
  left: 28.875rpx;
  margin-top: 31.25rpx;
  width: 583.33rpx;
  height: 343.75rpx;
  border-radius: 10.4rpx;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 31.25rpx 15.625rpx;
  gap: 10rpx;
  background: #F8F8F8;

  div {
    width: 552rpx;
    font-size: 21rpx;
    line-height: 1.5;
    color: #3D3D3D;
    margin-bottom: 20rpx;
  }
}

// 健康评估
.health-box {
  position: relative;
  margin-top: 31.25rpx;
  width: 670rpx;
  height: 839rpx;
  border-radius: 20rpx;
  padding: 6rpx;
  box-sizing: border-box;
  background: rgba(175, 225, 255, 0.5);
  border: 2px solid rgba(255, 255, 255, 0.5);
  box-shadow: 0px 2px 10px 0px rgba(42, 150, 225, 0.3);
  z-index: 4;
}

.health-title {
  position: relative;
  left: 0;
  top: 0;
  width: 177rpx;
  height: 46.875rpx;
  border-radius: 26rpx 26rpx 26rpx 0;
  text-align: center;
  line-height: 46.875rpx;
  font-size: 26rpx;
  color: #fff;
  display: flex;
  justify-content: center;
  align-items: center;
  background: linear-gradient(284deg, #2397F0 22%, #94DE30 99%);
}

.health-body {
  position: relative;
  left: 19rpx;
  margin-top: 31.25rpx;
  width: 616rpx;
  height: 558rpx;
  z-index: 0;
}

.health-body-img {
  position: absolute;
  width: 100%;
  height: 100%;
}

.health-line-left {
  position: absolute;
  left: 0rpx;
  top: 34rpx;
  width: 186rpx;
  height: 495.25rpx;
  display: flex;
  flex-direction: column;
}

.health-line-right {
  position: absolute;
  right: 10rpx;
  top: 34rpx;
  width: 177rpx;
  height: 406.25rpx;
  display: flex;
  flex-direction: column;
}

.health-line-left-item,
.health-line-right-item {
  width: 186rpx;
  height: 51.67rpx;
  border-radius: 1000rpx;
  background: rgba(14, 110, 184, 0.06);
  box-sizing: border-box;
  border: 2rpx solid #0E6EB8;
  color: #0E6EB8;
  font-size: 22.4rpx;
  text-align: center;
  line-height: 51.67rpx;
  cursor: pointer;
  margin-bottom: 37rpx;
}

// 健康评估颜色类
.line-red {
  background: rgba(255, 77, 79, 0.06) !important;
  border: 2rpx solid #FF4D4F !important;
  color: #FF4D4F !important;
}

.line-yellow {
 background: rgba(250, 140, 22, 0.06) !important;
  border: 2rpx solid #FA8C16 !important;
  color: #FA8C16 !important;
}

.line-green {
  background: rgba(144, 187, 85, 0.06)!important;
  border: 2rpx solid #90BB55 !important;
  color: #90BB55 !important;
}

.health-standard {
  position: relative;
  left: 20.875rpx;
  margin-top: 31.25rpx;
  box-sizing: border-box;
  width: 616.5rpx;
  height: 130rpx;
  border-radius: 10.4rpx;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  gap: 38rpx;
  background: #F8F8F8;
}

.health-standard-item {
  position: relative;
  width: 200rpx;
  height: 76rpx;
  display: flex;
  flex-direction: column;
  gap: 15.625rpx;
}

.health-standard-item-li {
  position: relative;
  height: 30.2rpx;
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 15.625rpx;

  div {
    width: 20.8rpx;
    height: 0;
    border: 2rpx solid #FF4D4F;
  }

  span {
    height: 30.2rpx;
    font-size: 20.8rpx;
    color: #FF4D4F;
  }
}

// 中医十二经分析
.twelve-box {
  position: relative;
  left: 0;
  margin-top: 31.25rpx;
  z-index: 5;
  width: 670rpx;
  border-radius: 20rpx;
  padding: 6rpx;
  box-sizing: border-box;
  background: rgba(175, 225, 255, 0.5);
  border: 2px solid rgba(255, 255, 255, 0.5);
  box-shadow: 0px 2px 10px 0px rgba(42, 150, 225, 0.3);
}

.twelve-title {
  position: relative;
  left: 0;
  top: 0;
  width: 260rpx;
  height: 46.875rpx;
  border-radius: 26rpx 26rpx 26rpx 0;
  text-align: center;
  line-height: 46.875rpx;
  font-size: 26rpx;
  color: #fff;
  display: flex;
  justify-content: center;
  align-items: center;
  background: linear-gradient(284deg, #2397F0 22%, #94DE30 99%);
}

.twelve-foreword {
  position: relative;
  left: 28.875rpx;
  margin-top: 26rpx;
  width: 583rpx;
  height: 132rpx;
  border-radius: 19.4rpx;
  color: #3D3D3D;
  font-size: 20.8rpx;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 20.8rpx 15.625rpx;
  gap: 5.2rpx;
  line-height: 1.5;
  background: #F8F8F8;
  letter-spacing: 1.5rpx;
}

.twelve-body {
  position: relative;
  left: 85rpx;
  margin-top: 31.25rpx;
  width: 468rpx;
  height: 374rpx;
  z-index: 1;
}

.twelve-bg {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
}
.twelve-type{
  position: absolute;
  top: 0rpx;
  left: 0rpx;
  width:123rpx;
  height: 374rpx;
}

.twelve-line-one,
.twelve-line-two,
.twelve-line-three,
.twelve-line-four,
.twelve-line-five {
  position: absolute;
  display: flex;

  div {
    width: 146rpx;
    height: 31.25rpx;
  }

  span {
    margin-left: 10.5rpx;
    font-size: 21rpx;
    width: 200rpx;
    height: 31.25rpx;
    line-height: 31.25rpx;
  }
}

.twelve-line-one {
  top: 55rpx;
  left: 125rpx;

  div {
    background-color: #EA0000;
  }
}

.twelve-line-two {
  top: 114rpx;
  left: 125rpx;

  div {
    background-color: #FA8C16;
  }
}

.twelve-line-three {
  top: 172rpx;
  left: 125rpx;

  div {
    background-color: #0E6EB8;
  }
}

.twelve-line-four {
  top: 230rpx;
  left: 125rpx;

  div {
    background-color: #90BB55;
  }
}

.twelve-line-five {
  top: 288rpx;
  left: 125rpx;

  div {
    background-color: #999999;
  }
}

.twelve-jing-box {
  position: relative;
  left: 28.875rpx;
  margin-top: 31.25rpx;
  width: 583rpx;
  height: 262rpx;
  border-radius: 10.5rpx;
  background: #F8F8F8;
}

.twelve-jing-box-img {
  position: absolute;
  left: 10.4rpx;
  top: 21.6rpx;
  width: 218.75rpx;
  height: 218.75rpx;
  border-radius: 10.4rpx;
}

.twelve-jing-box-message {
  position: absolute;
  left: 240rpx;
  margin-top: 20.8rpx;
  width: 333.33rpx;
  height: 220.3rpx;
  overflow: scroll;
  font-size: 15.6rpx;
  line-height: 1.5;
  text-align: justify;
  color: #3D3D3D;
  display: flex;
  flex-direction: column;
  gap: 8.3rpx;
}

.twelve-jing-box-name {
  font-size: 20.8rpx;
  color: #0E6EB8;
}
u
.twelve-jing-box-title {
  color: #3D3D3D;
  font-weight: 800;
  line-height: 1.5;
}

.twelve-jing-bottom {
  position: relative;
  left: 28.875rpx;
  margin-top: 31.25rpx;
  width: 583.3rpx;
  height: 102rpx;
  border-radius: 10.4rpx;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 20.8rpx 15.625rpx;
  gap: 5.2rpx;
  line-height: 1.5;
  letter-spacing: 1.5rpx;
  color: #3D3D3D;
  background: #F8F8F8;
  font-size: 20.8rpx;
  z-index: 4;
}

// 免责声明
.disclaimer-box {
  position: relative;
  left: -36rpx;
  margin-top: 31.25rpx;
  width: 750rpx;
  height: 1132rpx;
  border-radius: 10.5rpx;
  display: flex;
  flex-direction: column;
  padding: 20rpx;
  line-height: 1.38;
  letter-spacing: 1rpx;
  font-size: 21.875rpx;
  color: #ffffff;
  z-index: 6;
  text-indent: 2em;
}

.disclaimer-box-title{
  font-size: 31.25rpx;
  text-indent: 0em;
  margin-bottom: 10rpx;
}

// 底部间距
.bottom-spacer {
  height: 40rpx;
  position: relative;
}


</style>